
/*console.log(metaobjectsData);*/

document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('searchInput');
    const searchBtn = document.getElementById('searchBtn');

    renderFAQs([]);
    renderFAQs(metaobjectsData);
    renderCategories(metaobjectsData);
    renderAllFaq(metaobjectsData);

    document.getElementById('searchBtnMob').addEventListener('click', function() {
        document.body.classList.toggle('search-active');
    });

    document.getElementById('searchBtnMobclose').addEventListener('click', function() {
        document.body.classList.toggle('search-active');
    });

    function renderFAQs(faqs, searchTerm = '') {

    }

    function renderAllFaq(metaobjectsData) {
        const faqContainer = document.getElementById('helpqamainsec');
        const urlParams = new URLSearchParams(window.location.search);
        const currentCategory = urlParams.get('category');

        // Filter by category if URL has one
        const filteredData = currentCategory
            ? metaobjectsData.filter(item => item.category === currentCategory)
            : metaobjectsData;

        filteredData.forEach(item => {
            const faqDiv = document.createElement('div');
            faqDiv.classList.add('faq-card');

            const questionDiv = document.createElement('div');
            questionDiv.classList.add('faq-question');
            questionDiv.innerHTML = `<a href="${item.pageurl}">${item.question}</a>`;

            const answerDiv = document.createElement('div');
            faqDiv.appendChild(questionDiv);
            faqContainer.appendChild(faqDiv);
        });
    }

    function renderCategories(metaobjectsData) {
        const container = document.getElementById('categoriesContainer');
        const catnametitle = document.getElementById('displycatname');
        const helpbredfirst = document.getElementById('helpbredfirst');

        const categories = new Set(); // Using a Set to store unique categories
        metaobjectsData.forEach(metaobject => {
            categories.add(metaobject.category); // Add each category to the Set
        });
        const uniqueCategories = Array.from(categories).sort((a, b) => a.localeCompare(b));

        /*console.log(uniqueCategories);*/

        container.innerHTML = '';
        categories.forEach((category, index) => {
            const card = document.createElement('div');
            const slug = category.toLowerCase()
                .replace(/\s+/g, '-')
                .replace(/[^\w\-]+/g, '');
            card.className = `category-card-${slug}`;
            card.innerHTML = `
                    <h3>${category}</h3>
                `;

            card.addEventListener('click', () => {
                const urlfix = "/pages/help-center-category"
                window.location.href = `${urlfix}?category=${encodeURIComponent(category)}`;
            });
            card.setAttribute('aria-label', `Category: ${category}`);
            container.appendChild(card);
        });

        const urlParams = new URLSearchParams(window.location.search);
        const selectcat = urlParams.get('category');

        catnametitle.textContent = selectcat;
        helpbredfirst.textContent = selectcat;
    }

    searchInput.addEventListener('keyup', function(e) {
        if (e.key === 'Enter') {
            handleSearch();
        }
    });

    const searchResultsDropdown = document.getElementById('searchResultsDropdown');

    function showDropdownResults(results, searchKeyword) {
        searchResultsDropdown.innerHTML = '';

        if (!results.length) {
            const noResults = document.createElement('div');
            noResults.className = 'search-result-item';
            noResults.textContent = 'No matches found';
            searchResultsDropdown.appendChild(noResults);
        } else {
            const regex = new RegExp(`(${searchKeyword})`, 'gi'); // Create a regex for the search keyword
            results.slice(0, 5).forEach((result, index) => {
                const item = document.createElement('a');
                item.className = 'search-result-item block';
                item.href = result.pageurl || '#';

                // Highlight the search keyword in the result question
                const highlightedText = result.question.replace(regex, '<span class="highlight">$1</span>');
                item.innerHTML = highlightedText; // Use innerHTML to include the highlighted text
                item.setAttribute('data-index', index);
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    searchInput.value = result.question;
                    handleSearch();
                    searchResultsDropdown.classList.add('hidden');
                    if (result.pageurl) {
                        window.location.href = result.pageurl;
                    }
                });
                searchResultsDropdown.appendChild(item);
            });
        }

        searchResultsDropdown.classList.remove('hidden');
    }

    function handleSearch() {
        const searchTerm = (searchInput.value || '').trim().toLowerCase();
        let filteredData = [...metaobjectsData];

        // Apply search filter as user types
       /* if (searchTerm) {
            filteredData = filteredData.filter(faq =>
                faq.question.toLowerCase().includes(searchTerm) ||
                faq.answer.toLowerCase().includes(searchTerm)
            );
        }*/

        renderFAQs(filteredData, searchTerm);
    }

    // Enable auto-search functionality
    searchInput.addEventListener('input', function() {
        const searchTerm = this.value.trim().toLowerCase();

        if (!searchTerm) {
            searchResultsDropdown.classList.add('hidden');
            handleSearch();
            return;
        }

        const results = metaobjectsData.filter(faq => {
            const question = faq.question ? String(faq.question) : '';
            const answer = faq.answer ? String(faq.answer) : '';
            return question.toLowerCase().includes(searchTerm) || answer.toLowerCase().includes(searchTerm);
        });

        showDropdownResults(results, searchTerm, searchInput.value);
    });

    // Hide dropdown when clicking outside
    document.addEventListener('click', function(e) {
        if (!searchInput.contains(e.target) && !searchResultsDropdown.contains(e.target)) {
            searchResultsDropdown.classList.add('hidden');
        }
    });
});


